import styled from 'styled-components';
import colors from 'themes/Main';
import {
  Field,
  Input,
  Textarea,
  Button,
} from 'semantix-design-system/components';

const { gray02, gray04, darkBlue, blue, danger, dangerBackground } = colors;

export const FormField = styled(Field)`
  font-weight: 700;
  flex: 1;
  margin-right: 16px;

  label {
    margin-top: 16px;
    color: ${darkBlue};
    font-size: 14px;
  }
`;

const colorGen = (type, hover = '') => {
  switch (type) {
    case 'cancel':
      return hover ? dangerBackground : danger;
    case 'disabled':
      return hover ? gray04 : gray02;
    default:
      return hover ? blue : darkBlue;
  }
};

export const FormInput = styled(Input)`
  padding: 8px 16px;
`;

export const TextField = styled(Textarea)`
  padding: 16px;
`;

export const FormButton = styled(Button)`
  ${({ kind }) => `
    &.icon {
      position: relative;
      text-align: center;
      outline: none;
      border: none;
      background: transparent !important;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 28px;
      height: 28px;

      svg {
        fill: ${colorGen(kind)};
        width: 24px ;
        height: 24px;
      }

      &:hover,
      &:focus {
        outline: none;
        border: none;
        svg{
          fill: ${colorGen(kind, 'hover')};
        }
      }
  `}
`;

export const FormRow = styled.div`
  ${({ error }) => `
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    height: auto;

    ${FormField} {
      margin: 0 16px 0 0;
    }

    ${FormButton} {
      &.icon {
        position: relative;
        margin: 0;
        margin-bottom: ${!error ? '6px' : '26px'}
      }
    }
 `}
`;

export const ButtonsWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 40px;

  button:first-of-type {
    margin-right: 8px;
  }
`;
